import { useState } from "react";
import { toast } from "sonner";
import { ListChecks } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const CompleteEntries = ({ kit, reload }) => {
  const [busy, setBusy] = useState(false);
  const n = kit.summary?.thin_entries || 0;
  if (!n && !kit.completing) return null;
  const run = async () => {
    setBusy(true);
    try { const { data } = await http.post(`/kits/${kit.id}/complete-entries`); toast.success(data.started ? `Completing ${data.thin} entries with full details — takes a few minutes` : "All entries already complete"); setTimeout(reload, 1500); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <button data-testid="complete-entries-button" onClick={run} disabled={busy || kit.completing} title="Rewrites entries that are short or missing address, hours, price, booking or tip — uses web search"
      className="inline-flex items-center gap-2 rounded-sm border border-amber-400 px-4 py-2 text-sm font-semibold text-amber-700 hover:bg-amber-50 disabled:opacity-50">
      <ListChecks size={15} /> {kit.completing ? "Completing entries…" : `Complete ${n} missing detail${n === 1 ? "" : "s"}`}
    </button>
  );
};
